export enum QuarantineAssignedGroup {
  POOL1 = 1,
  POOL2 = 2,
  POOL3 = 3,
  POOL4 = 4,
  POOL5 = 5,
  POOL6 = 6,
  POOL7 = 7,
  POOL8 = 8,
  POOL9 = 9,
  POOL10 = 10,
}
